
    <div v-if="sticker" class="w-100">
        <!--
        <v-row class="no-frame">
            <v-col class="no-frame" style="text-align: center">
                <v-select
                    v-if           = "items"
                    :items         = "items"
                    v-model        ="selected"
                    item-value     = "id"
                    item-text      = "name"
                    :return-object = true
                    @input         = "onQrCode"
                    hide-details
                    dense
                />
            </v-col>
        </v-row>
        -->

        <v-row class="no-frame mt-0">
            <v-col class="no-frame " style="text-align: left">
                <v-select
                    v-if           = "items"
                    :items         = "items"
                    v-model        ="selected"
                    item-value     = "id"
                    item-text      = "name"
                    :return-object = true
                    @input         = "onQrCode"
                    hide-details
                    dense
                />
                <div style="font-size: 9px; margin-top: 4px">
                    {{ selected ? selected.id : '---' }}
                </div>
            </v-col>
            <v-col class="no-frame ml-2 mt-n3" style="text-align: center">
                <canvas id="canvas" class="w-100"></canvas>
            </v-col>
        </v-row>
<!--
        <v-row class="no-frame mt-n1">
            <v-col class="no-frame" style="text-align: center; font-size: 14px;">
                {{ selected ? selected.id : '---' }}
            </v-col>
        </v-row>
        -->
    </div>
